"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("./Types");
var FetchHttpService = /** @class */ (function () {
    function FetchHttpService(config) {
        this.config = config;
    }
    FetchHttpService.prototype.get = function (route, options) {
        return this.execute(Types_1.HttpMethod.get, route, null, options);
    };
    FetchHttpService.prototype.post = function (route, body, options) {
        return this.execute(Types_1.HttpMethod.post, route, body, options);
    };
    FetchHttpService.prototype.put = function (route, body, options) {
        return this.execute(Types_1.HttpMethod.put, route, body, options);
    };
    FetchHttpService.prototype.patch = function (route, body, options) {
        return this.execute(Types_1.HttpMethod.patch, route, body, options);
    };
    FetchHttpService.prototype.delete = function (route, options) {
        return this.execute(Types_1.HttpMethod.delete, route, null, options);
    };
    FetchHttpService.prototype.execute = function (method, route, body, options, isRetry) {
        if (options === void 0) { options = {}; }
        if (isRetry === void 0) { isRetry = false; }
        return __awaiter(this, void 0, void 0, function () {
            var interceptors, baseUrl, path, url, defaultHeaders, req, _i, interceptors_1, interceptor, bodyToSend, res, _a, interceptors_2, interceptor, retryHandler, err_1, contentType;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.retryHandler && !isRetry)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.retryHandler];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        interceptors = this.config.interceptors || [];
                        baseUrl = options.baseUrl || this.config.baseUrl;
                        path = typeof route === 'string' ? route : route.join('/');
                        url = new URL(baseUrl + '/' + path);
                        defaultHeaders = this.config.defaultHeaders || new Headers();
                        if (options.query) {
                            Object.entries(options.query).forEach(function (_a) {
                                var key = _a[0], value = _a[1];
                                if (value) {
                                    url.searchParams.append(key, value.toString());
                                }
                            });
                        }
                        req = {
                            url: url.toString(),
                            method: method,
                            body: body || null,
                            headers: defaultHeaders,
                        };
                        _i = 0, interceptors_1 = interceptors;
                        _b.label = 3;
                    case 3:
                        if (!(_i < interceptors_1.length)) return [3 /*break*/, 6];
                        interceptor = interceptors_1[_i];
                        if (!interceptor.willSendRequest) return [3 /*break*/, 5];
                        return [4 /*yield*/, interceptor.willSendRequest(req)];
                    case 4:
                        req = _b.sent();
                        _b.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 3];
                    case 6:
                        if (req.body instanceof Blob || req.body instanceof FormData || typeof (req.body) === 'string' || req.body instanceof URLSearchParams) {
                            bodyToSend = req.body;
                        }
                        else if (req.body && typeof (req.body) === 'object') {
                            defaultHeaders.set('Content-type', 'application/json');
                            bodyToSend = JSON.stringify(req.body);
                        }
                        else {
                            bodyToSend = req.body;
                        }
                        return [4 /*yield*/, fetch(req.url, {
                                body: bodyToSend,
                                method: req.method,
                                headers: req.headers,
                                credentials: options.credentials
                            })];
                    case 7:
                        res = _b.sent();
                        _a = 0, interceptors_2 = interceptors;
                        _b.label = 8;
                    case 8:
                        if (!(_a < interceptors_2.length)) return [3 /*break*/, 16];
                        interceptor = interceptors_2[_a];
                        if (!(interceptor.willHandleRetry && !isRetry)) return [3 /*break*/, 13];
                        retryHandler = interceptor.willHandleRetry(req, res);
                        if (!retryHandler) return [3 /*break*/, 13];
                        _b.label = 9;
                    case 9:
                        _b.trys.push([9, 11, 12, 13]);
                        this.retryHandler = retryHandler;
                        return [4 /*yield*/, this.retryHandler];
                    case 10:
                        _b.sent();
                        return [2 /*return*/, this.execute(method, route, body, options, true)];
                    case 11:
                        err_1 = _b.sent();
                        return [3 /*break*/, 13];
                    case 12:
                        this.retryHandler = undefined;
                        return [7 /*endfinally*/];
                    case 13:
                        if (!interceptor.willHandleResponse) return [3 /*break*/, 15];
                        return [4 /*yield*/, interceptor.willHandleResponse(res)];
                    case 14:
                        res = _b.sent();
                        _b.label = 15;
                    case 15:
                        _a++;
                        return [3 /*break*/, 8];
                    case 16:
                        if (res.ok) {
                            contentType = res.headers.get("content-type");
                            if (contentType && contentType.indexOf("application/json") !== -1) {
                                return [2 /*return*/, res.json()];
                            }
                            else {
                                return [2 /*return*/, res];
                            }
                        }
                        else {
                            throw res;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return FetchHttpService;
}());
exports.FetchHttpService = FetchHttpService;
